<template lang="pug">
header.tfm-header
	.appname-container.header-section.header-section-shrinkable
		main-hamburger-menu
		a.header-menu-item#logo(href="/") TFM
			strong.env.is-error(v-if="showEnv")
				= " "
				| {{ envName }}
		p.is-warning.header-menu-item.no-wrap.no-overflow#debug-warning(v-show="$store.state.isDebug")
			=" Running locally causes times to display UTC"

	.logos-container.header-section
		//- the logout option is already in the hamburger menu
		//- .user.hover-dropdown-toggle.header-menu-item(v-if="typeof username === 'string'")
			i.fa.fas.fa-user
			| {{ username }}
			ul.hover-dropdown
				li: a.hover-dropdown-item(href="/Account/Logout") Logout
		.logos.header-menu-item
			a.linkback(:href="$store.state.client.linkUrl" target="_blank" rel="noopener noreferrer")
				img.linkback(:src="$store.state.client.logoImageUrl" :alt="$store.state.client.name")
			a.linkback(href="http://www.mixonhill.com" target="_blank" rel="noopener noreferrer")
				img.linkback(src="/Images/MHLogoGreen_reg.png" alt="Mixon Hill")
</template>

<script>
// import Vue from "vue";
import MainHamburgerMenu from "./MainHamburgerMenu";
import EnvAware from "@/mixins/EnvAware";
import Component, { mixins } from "vue-class-component";

@Component({
	components: {
		MainHamburgerMenu
	}
})
class SiteHeader extends mixins(EnvAware) {
	get username() {
		return this.$store.state.user.username;
	}

	get showEnv() {
		return !this.getIsProductionEnvironment();
	}

	get envName() {
		const e = this.getCurrentEnvironmentData();
		return e.shortName.toUpperCase();
	}
}

export default SiteHeader;
</script>

<style lang="stylus">
.env
	margin-left 0.25em

.tfm-header
	line-height 1em
	text-shadow 0 0.05em 0.05em #000
	z-index 1005
	display flex
	justify-content space-between
	align-items center
	align-content center
	background-color #2a406c
	color #fff
	position relative

	p
		font-size inherit
		margin 0

	a
		font-size inherit
		color #fff
		text-decoration none

		&.hover-dropdown-item
			color #333

	#logo
		font-size 1.75rem
		line-height 1em
		font-weight 500
		padding 0 1rem
		transition background-color 0.2s ease

		&:hover
			background rgba(255, 255, 255, 0.2)

	.header-section
		display flex
		align-items stretch
		position relative

		&.header-section-shrinkable
			flex 1 1 auto
			min-width 0

		.header-menu-item
			display flex
			align-items center
			align-content center

	.copyright
		width 100%
		font-size 1rem
		color #999

	.user
		padding 1em

		.fa-user
			margin-right 1rem

	.logos
		margin-left 1rem

		@media screen and (max-width 1000px)
			flex-direction column
			align-content flex-end
			justify-content center

		img
			margin 0.6rem 0.6rem 0.6rem 0
			height 1.87rem

			@media screen and (max-width 1000px)
				height 1.13rem
				margin 0
				padding 0

	.hover-dropdown-toggle
		cursor pointer
		position relative
		transition background 0.2s ease

		&:hover
			background-color rgba(255, 255, 255, 0.3)

	.hover-dropdown
		-webkit-appearance inherit
		border 0
		border-radius 0
		background transparent
		position absolute
		list-style none
		margin 0
		padding 0
		top 100%
		left 0
		right 0
		opacity 0
		z-index 1001
		visibility hidden
		transition opacity 0.2s ease
		box-shadow rgba(0, 0, 0, 0.2) 0px 0.1em 0.2em

	.hover-dropdown:hover,
	.hover-dropdown-toggle:hover .hover-dropdown
		visibility visible
		opacity 1

	.dropdown-direction-up .hover-dropdown
		top inherit
		left inherit
		bottom 100%

	.hover-dropdown .hover-dropdown-item
		text-align left
		display flex
		justify-content flex-start
		padding 0.5em
		color #333
		text-shadow 0 0.05em 0.05em #fff
		background-color #fff
		transition background 0.2s ease

	.hover-dropdown .hover-dropdown-item.disable
		color #888
		background #ddd

	.hover-dropdown a.hover-dropdown-item:hover
		background-color #eee
</style>
